import React from "react";
import { Img } from "../..";
import AvatarImg from "./avatar.png";

function Avatar({ letter = "a", photo, className = "w-6 h-6", preview }) {
	return <Img preview={preview} placeholder={AvatarImg} src={photo} className={`rounded-full pixelated ${className}`} />;
}

export default Avatar;
